import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CommonUtil } from "../../../utils/CommonUtil";
import SelectField from "../../../Components/SelectField";
import InputField from "../../../Components/InputField";
import { Constants } from "../../Languages/Constants";
import { NetworkManager } from "../../../Components/NetworkManager";
import { on } from "events";
import ToastManager from "../../../Components/ToastManager";

const SettleClaim = ({ mode, onClose, data }: any) => {
  const formik = useFormik({
    initialValues: {
      status: "",
      description: "",
    },
    validationSchema: Yup.object({
      status: Yup.string().required("Status is required"),
    }),
    onSubmit: (values) => {
      onSubmitForm(values)
    },
  });

  const onSubmitForm = (values: any) => {
      const payload: any = {
        claimId: data?.claimId,
        responseMessage: values.description,
        responseStatus: values.status,
        saasOrgId: CommonUtil.getSaasOrgId(),
      };
  
      const api: string = `api/claim/message/?isForInterchange=true`;
  
      NetworkManager.sendJsonRequest(api, payload , "", "POST", true, onSaveResponse, (err: any) => {
        console.log(err);
      });
    }

  const onSaveResponse = (dataObj:any) => {
    if (dataObj) {
      var restData = CommonUtil.parseData(dataObj);
      if (restData && !restData.errorMessage) {
        formik.resetForm();
        onClose();
        ToastManager.showToast("Claims Settled successfully", "Info") 
      }
    }
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="col-md-12">
        <div className="form-group">
          <SelectField
            name="status"
            placeholder={CommonUtil.getMessageText(Constants.STATUS, "Status")}
            onChange={formik.handleChange}
            value={formik.values.status}
            onBlur={formik.handleBlur}
          >
            <option value="" disabled>Select</option>
            {CommonUtil.CLAIM_STATUES?.map((item: any, i: any) => (
              <option key={i} value={item.key}>
                {item.value}
              </option>
            ))}
          </SelectField>
          {formik.touched.status && formik.errors.status && (
            <small className="ms-2 text-danger fw-700">{formik.errors.status}</small>
          )}
        </div>

        <div className="form-group">
          <InputField
            rows={4}
            name="description"
            placeholder={CommonUtil.getMessageText(Constants.ENTER_DESCRIPTION, "Enter Description")}
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </div>
      </div>

      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-outline-dark"
          data-bs-dismiss="modal"
          onClick={() => onClose()}
        >
          {CommonUtil.getMessageText(Constants.CLOSE, "Cancel")}
        </button>
        <button type="submit" className="btn btn-success">
          {CommonUtil.getMessageText(Constants.SUBMIT, "Submit")}
        </button>
      </div>
    </form>
  );
};

export default SettleClaim;
